import { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';

import { sendResetPasswordEmail } from '../api/auth';

import Input from '../components/input/input';

class ForgotPassword extends PureComponent {
  state = {
    password: '',
    isValid: true,
    errors: null,
  };

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  async onSubmit() {
    const { email } = this.state;

    if (this.isValid()) {
      await sendResetPasswordEmail({ email });
    } else {
      this.setState({ isValid: this.isValid() });
      window.scrollTo(0, 0);
    }
  }

  isValid() {
    const { email } = this.state;
    return email !== '';
  }

  render() {
    const { email, isValid, errors } = this.state;

    const messageBox = errors && (
      <div className="errors">
        {errors &&
          errors.map((error, index) => (
            <span key={index}>{error.message}</span>
          ))}
      </div>
    );

    return (
      <main className="th-main">
        <section className="th-canvas">
          <header className="th-canvas-header"></header>
          <div>
            <div className="auth">
              <div className="header">
                <h1>Submit your email to reset your password.</h1>
              </div>
              {messageBox}
              <div className="w-100 flex flex-column items-start justify-between mt10">
                <div className="w-100">
                  <Input
                    name="email"
                    type="text"
                    label="Email*"
                    value={email}
                    valid={isValid || email !== ''}
                    onChange={(event) => this.onChange(event)}
                  />
                </div>
              </div>
              <div className="action">
                <button
                  className="btn-green"
                  data-cy="submit"
                  onClick={() => this.onSubmit()}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </section>
      </main>
    );
  }
}

export default withRouter(ForgotPassword);
